module.exports = __webpack_public_path__ + "2624580f3bcb9830da0a7b8efd84eed0.png";